// extracted by mini-css-extract-plugin
export default {"optionsContainer":"SectionItemsOptions_optionsContainer__pALFf","lightBg":"SectionItemsOptions_lightBg__HmDYt","decreaseDimensions":"SectionItemsOptions_decreaseDimensions__blguy"};